exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".RQ04C{display:flex;justify-content:flex-start;flex-direction:row;min-height:30px}.RQ04C .ssiZb{flex:1;min-width:0}.RQ04C .ssiZb ._2vQYL{margin-left:-10px}.RQ04C .ssiZb ._2vQYL.A7B2b{position:absolute}.RQ04C .ssiZb ._2QoRL{display:flex}.RQ04C .ssiZb ._2QoRL._1ZNhU{position:absolute}.RQ04C .ssiZb ._2QoRL .CYuj8{position:relative;top:6px;left:-12px;z-index:1;width:36px;height:36px}.RQ04C .ssiZb ._2QoRL .CYuj8 button{color:#3899EC;border:none;background-color:transparent}.RQ04C .ssiZb ._2QoRL .CYuj8 button:hover{background-color:#fff}.RQ04C .ssiZb ._2QoRL .CYuj8 button:active{background-color:rgba(255,255,255,0.7)}.RQ04C .ssiZb ._2QoRL .CYuj8._3G-11 button{color:#fff}.RQ04C .ssiZb ._2QoRL .CYuj8._3G-11 button:hover{background-color:rgba(255,255,255,0.3)}.RQ04C .ssiZb ._2QoRL .CYuj8._3G-11 button:active{background-color:rgba(255,255,255,0.2)}.RQ04C .ssiZb ._2QoRL .CYuj8 ._146kZ{display:block;width:36px;height:36px;position:relative;left:-1px}.RQ04C .ssiZb ._2QoRL ._1_lMI{min-width:0}.RQ04C .ssiZb ._2QoRL ._1_lMI .y5QPa{height:48px}.RQ04C ._3nq4K{height:30px;margin-top:6px;margin-left:auto}.RQ04C ._3nq4K._3ZKcf{margin-top:36px}.RQ04C ._3nq4K._1ZNhU{margin-top:-3px}.rtl ._2vQYL,[dir='rtl'] ._2vQYL{margin-left:0;margin-right:-10px}.rtl .CYuj8,[dir='rtl'] .CYuj8{left:12px}.rtl ._146kZ,[dir='rtl'] ._146kZ{transform:scaleX(-1)}\n", ""]);

// Exports
exports.locals = {
	"D10": "#162D3D",
	"d10": "#162D3D",
	"D20": "#32536A",
	"d20": "#32536A",
	"D30": "#577083",
	"d30": "#577083",
	"D40": "#7A92A5",
	"d40": "#7A92A5",
	"D50": "#B6C1CD",
	"d50": "#B6C1CD",
	"D55": "#CBD3DC",
	"d55": "#CBD3DC",
	"D60": "#DFE5EB",
	"d60": "#DFE5EB",
	"D70": "#F0F4F7",
	"d70": "#F0F4F7",
	"D80": "#fff",
	"d80": "#fff",
	"B00": "#2B81CB",
	"b00": "#2B81CB",
	"B05": "#308DDD",
	"b05": "#308DDD",
	"B10": "#3899EC",
	"b10": "#3899EC",
	"B20": "#4EB7F5",
	"b20": "#4EB7F5",
	"B25": "#A1D7FB",
	"b25": "#A1D7FB",
	"B27": "#B3E0FB",
	"b27": "#B3E0FB",
	"B30": "#C1E4FE",
	"b30": "#C1E4FE",
	"B40": "#DAEFFE",
	"b40": "#DAEFFE",
	"B50": "#EAF7FF",
	"b50": "#EAF7FF",
	"B60": "#F4FAFE",
	"b60": "#F4FAFE",
	"F00": "#AADBFC",
	"f00": "#AADBFC",
	"P00": "#8E21B1",
	"p00": "#8E21B1",
	"P10": "#AA4DC8",
	"p10": "#AA4DC8",
	"P20": "#CD68ED",
	"p20": "#CD68ED",
	"P30": "#E5C9EE",
	"p30": "#E5C9EE",
	"P40": "#EEDBF4",
	"p40": "#EEDBF4",
	"P50": "#FAEEFF",
	"p50": "#FAEEFF",
	"P60": "#FAF7FC",
	"p60": "#FAF7FC",
	"O00": "#EA5F0E",
	"o00": "#EA5F0E",
	"O10": "#FB7D33",
	"o10": "#FB7D33",
	"O20": "#FF9A48",
	"o20": "#FF9A48",
	"R00": "#D6453D",
	"r00": "#D6453D",
	"R05": "#D8504C",
	"r05": "#D8504C",
	"R10": "#EE5951",
	"r10": "#EE5951",
	"R20": "#f66",
	"r20": "#f66",
	"R30": "#FFD7D7",
	"r30": "#FFD7D7",
	"R40": "#FFE1E1",
	"r40": "#FFE1E1",
	"R50": "#FFEBEB",
	"r50": "#FFEBEB",
	"R60": "#FFF5F5",
	"r60": "#FFF5F5",
	"G00": "#44823F",
	"g00": "#44823F",
	"G05": "#61AD5A",
	"g05": "#61AD5A",
	"G10": "#60BC57",
	"g10": "#60BC57",
	"G20": "#80C979",
	"g20": "#80C979",
	"G30": "#C9EEBC",
	"g30": "#C9EEBC",
	"G40": "#DEF4D4",
	"g40": "#DEF4D4",
	"G50": "#EDF9E5",
	"g50": "#EDF9E5",
	"G60": "#F2FBEF",
	"g60": "#F2FBEF",
	"Y00": "#C68801",
	"y00": "#C68801",
	"Y05": "#EDA200",
	"y05": "#EDA200",
	"Y10": "#FDB10C",
	"y10": "#FDB10C",
	"Y20": "#FAC249",
	"y20": "#FAC249",
	"Y30": "#FEF0BA",
	"y30": "#FEF0BA",
	"Y40": "#FEF4CD",
	"y40": "#FEF4CD",
	"Y50": "#FDF7DF",
	"y50": "#FDF7DF",
	"Y60": "#FFFCF0",
	"y60": "#FFFCF0",
	"A1": "#3370FB",
	"a1": "#3370FB",
	"A2": "#7852D2",
	"a2": "#7852D2",
	"A3": "#17B0E2",
	"a3": "#17B0E2",
	"A4": "#C53E99",
	"a4": "#C53E99",
	"A5": "#FDB10C",
	"a5": "#FDB10C",
	"A6": "#3D9FA1",
	"a6": "#3D9FA1",
	"B1": "#EF73C0",
	"b1": "#EF73C0",
	"B2": "#FF8D41",
	"b2": "#FF8D41",
	"B3": "#ED6779",
	"b3": "#ED6779",
	"B4": "#125b8f",
	"b4": "#125b8f",
	"C1": "#4abd81",
	"c1": "#4abd81",
	"C2": "#2682CD",
	"c2": "#2682CD",
	"C3": "#68A4D5",
	"c3": "#68A4D5",
	"C4": "#FF8E8C",
	"c4": "#FF8E8C",
	"D10-05": "rgba(22,45,61,0.05)",
	"d1005": "rgba(22,45,61,0.05)",
	"D10-10": "rgba(22,45,61,0.1)",
	"d1010": "rgba(22,45,61,0.1)",
	"D10-20": "rgba(22,45,61,0.2)",
	"d1020": "rgba(22,45,61,0.2)",
	"D10-30": "rgba(22,45,61,0.3)",
	"d1030": "rgba(22,45,61,0.3)",
	"headerContainer": "RQ04C",
	"header": "ssiZb",
	"breadcrumbsContainer": "_2vQYL",
	"absolute": "A7B2b",
	"titleContainer": "_2QoRL",
	"minimized": "_1ZNhU",
	"backButton": "CYuj8",
	"darkTheme": "_3G-11",
	"backButtonIcon": "_146kZ",
	"titleColumn": "_1_lMI",
	"title": "y5QPa",
	"actionsBar": "_3nq4K",
	"withBreadcrumbs": "_3ZKcf"
};